import API from './api';

const adminService = {
  getPerfiles: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/perfiles`,
      params: params,
      interceptor: conInterceptor
    });
  },

  getPerfil: function (codigoPerfil, params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/perfiles/${codigoPerfil}`,
      params: params,
      interceptor: conInterceptor
    });
  },

  postPerfil: function (data, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: `/perfiles`,
      data: data,
      interceptor: conInterceptor
    });
  },

  putPerfil: function (codigoPerfil, data, conInterceptor = true) {
    return API.axios({
      method: 'put',
      url: `/perfiles/${codigoPerfil}`,
      data: data,
      interceptor: conInterceptor
    });
  },

  deletePerfil: function (codigoPerfil, conInterceptor = true) {
    return API.axios({
      method: 'delete',
      url: `/perfiles/${codigoPerfil}`,
      interceptor: conInterceptor
    });
  },

  getPermisos: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/permisos`,
      params: params,
      interceptor: conInterceptor
    });
  },

  getPermiso: function (codigoPermiso, params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/permisos/${codigoPermiso}`,
      params: params,
      interceptor: conInterceptor
    });
  },

  getGrupos: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/grupos`,
      params: params,
      interceptor: conInterceptor
    });
  },

  getGrupo: function (codigoGrupo, params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/grupos/${codigoGrupo}`,
      params: params,
      interceptor: conInterceptor
    });
  },

  postGrupo: function (data, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: `/grupos`,
      data: data,
      interceptor: conInterceptor
    });
  },

  putGrupo: function (codigoGrupo, data, conInterceptor = true) {
    return API.axios({
      method: 'put',
      url: `/grupos/${codigoGrupo}`,
      data: data,
      interceptor: conInterceptor
    });
  },

  deleteGrupo: function (codigoGrupo, conInterceptor = true) {
    return API.axios({
      method: 'delete',
      url: `/grupos/${codigoGrupo}`,
      interceptor: conInterceptor
    });
  },

  validarGrupoRegistrado: function (nombreGrupo, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/grupos/grupo-registrado`,
      params: { nombreGrupo },
      interceptor: conInterceptor
    });
  }
};

export default adminService;
